import Vue from 'vue'
import AscGridFolderCell from '@/components/molecules/AscGridFolderCell'

export default Vue.extend({
  components: {
    AscGridFolderCell,
  },

  data: function () {
    return {}
  },

  computed: {
    getDataValue() {
      return this.params.value
    },
  },

  template: `<asc-grid-folder-cell 
  :value="getDataValue" />`,
})
